import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { AuthSignalService } from '../state/auth.signal';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {
  private messaging: any;

  constructor(
    private http: HttpClient,
    private authSignal: AuthSignalService
  ) {
    // Only initialize if config is present and we're in a browser
    if (typeof window !== 'undefined' && environment.firebaseConfig && environment.firebaseConfig.apiKey) {
      try {
        const app = initializeApp(environment.firebaseConfig);
        this.messaging = getMessaging(app);
      } catch (e) {
        console.error('Firebase initialization failed', e);
      }
    }
  }

  async init() {
    if (!this.messaging) return;

    try {
      // Pedimos permiso — Si ya se concedió, simplemente devuelve 'granted'
      const permission = await Notification.requestPermission();
      
      if (permission === 'granted') {
        // En lugar de registrarlo manualmente, dejamos que Firebase 
        // use el archivo '/firebase-messaging-sw.js' que pusimos en public.
        const token = await getToken(this.messaging, { 
          vapidKey: environment.vapidKey
        });

        if (token) {
          await this.saveToken(token);
        }
      }
    } catch (error) {
      console.error('Error in PushNotificationService.init:', error);
    }
  }

  async logout() {
    if (!this.messaging) return;
    try {
      const token = await getToken(this.messaging, { vapidKey: environment.vapidKey });
      if (token) {
        await this.http.post(`${environment.apiUrl}/notifications/token/remove`, { token }).toPromise();
      }
    } catch (error) {
      console.error('Error during push notification logout:', error);
    }
  }

  private async saveToken(token: string) {
    try {
      await this.http.post(`${environment.apiUrl}/notifications/token`, {
        token,
        device: navigator.userAgent
      }).toPromise();
    } catch (error) {
      console.error('Failed to register FCM token', error);
    }
  }

  listenForMessages() {
    if (!this.messaging) return;
    onMessage(this.messaging, (payload: any) => {
      console.log('Message received in foreground. ', payload);
      // The browser can show a notification manually here if desired
    });
  }
}
